<app-loading
  [loading] = loading
></app-loading>

<div class="modal-overlay" *ngIf="habilitarEdicao" (click)="!loading && fecharModal()">
  <div class="box-detalhes-cliente" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-edit"></i> Detalhes do Cliente
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12">
        <h4 class="text-blue">Cliente: {{cliente.nome}}</h4>
      </div>
      <div class="col-md-4">Data Cadastro: <br><b>{{cliente.dataCadastro | date:"dd-MM-yyyy" }}</b></div>
      <div class="col-md-4">Tipo Documento: <br><b>{{cliente.tipoDocumentoDescricao}}</b></div>
      <div class="col-md-4">Contato: <br><b>{{cliente.telefone | telefoneFormat}}</b></div>
    </div>

    <hr>

    <div class="row g-3" *ngIf="cliente.id > 0">
      <div class="col-md-12">Documento: <br><b>{{cliente.documento | documentoFormat:cliente.tipoDocumentoDescricao}}</b></div>
    </div>

    <hr>

    <form [formGroup]="formAlterarDados" class="row g-3 mt-2">
      <div class="col-md-12">
        <label for="nome" class="form-label">Nome</label>
        <input type="text" class="form-control" formControlName="nome" id="nome" placeholder="Nome do cliente">
      </div>

      <div class="col-md-4">
        <label for="tipoDocumento" class="form-label">Tipo Documento</label>
        <ng-select
          id="tipoDocumento"
          [items]="listaTipoDocumento"
          bindLabel="descricao"
          bindValue="id"
          formControlName="tipoDocumento"
          (change)="definirMascaraDocumento()"
          placeholder="Selecione">
        </ng-select>
      </div>

      <div class="col-md-4">
        <label for="documento" class="form-label">Documento</label>
        <input type="text" class="form-control" formControlName="documento" id="documento"
               [mask]="mascaraDocumento" placeholder="Número do documento">
      </div>

      <div class="col-md-4">
        <label for="telefone" class="form-label">Telefone</label>
        <input type="text" class="form-control" formControlName="telefone" id="telefone"
               mask="(00) 0 0000-0000||(00) 0000-0000" placeholder="Telefone do cliente">
      </div>

      <div class="col-md-12 d-flex justify-content-between gap-2 mt-4">
        <div>
          <button *ngIf="cliente.ativo" type="button" class="btn btn-outline-danger" (click)="desativar()" [disabled]="loading">
            <i class="fa fa-recycle"></i> Desativar
          </button>
          <button *ngIf="!cliente.ativo" type="button" class="btn btn-outline-secondary" disabled>
            <i class="fa fa-recycle"></i> Desativado
          </button>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-light" (click)="fecharModal()" [disabled]="loading">Cancelar</button>
          <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvarAlteracoes()" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loading ? 'Salvando...' : 'Salvar Alterações' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
